import axios from "axios";
import Session from "supertokens-auth-react/recipe/session";

const defaultHeaders = {
	Accept: "application/json",
	"Content-Type": "application/json;charset=UTF-8",
};

const fallbackErrorMessage = "Something went wrong! Please try again after some time";

function throwError(message, code) {
    const error = new Error(message);
    error.code = code; // Attach code to error object
    throw error;
}

async function populateRequest(method, { url, skipAuth, data, config }) {
    config = config || {};

    // Merge existing headers with default headers
    config.headers = { ...defaultHeaders, ...config.headers };

    if (!skipAuth) {
        // const accessToken = await Session.getAccessToken();
        // console.log(accessToken);

		// if (!accessToken) {
		// 	throwError('FAiled to Fetch Access Token', 'COULD_NOT_FETCH_ACCESS_TOKEN');
		// }

		// config.headers["Xook-Access-Token"] = accessToken;
    }

    // Set the data in the config object for applicable methods
    if (method !== 'GET' && data) {
        config.data = data;
    }

    config.method = method;
    config.url = url;

    return config;
}

async function makeHttpRequest(method, props) {

    let requestConfig;

    try {
        requestConfig = await populateRequest(method ,props);
    } catch(error) {
        //Handle payload errors seperately, as these might be crucial errors.
        return {
            error: error?.message || fallbackErrorMessage,
            errorCode: error?.code
        };
    }

    try {
        let response = await axios(requestConfig);
        return { data: response.data?.data };

    } catch (error) {
        //Handling API errors.
        return {
            error: error?.response?.data?.message || error?.message || fallbackErrorMessage,
            errorCode: error?.code,
            metadata: error?.response?.data?.metadata
        };
    }
}

export async function get(props) {
    return makeHttpRequest("GET", props);
}

export async function post(props) {
    return makeHttpRequest('POST', props);
}

export async function put(props) {
    return makeHttpRequest('PUT', props);
}

export async function patch(props) {
    return makeHttpRequest('PATCH', props);
}
